/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Personality_GeneratedInputs */

const en_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Personality generated ✨`)
};

const es_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalidad IA generada ✨`)
};

const fr_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnalité IA générée ✨`)
};

const de_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Persönlichkeit generiert ✨`)
};

const ja_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIペルソナが生成されました ✨`)
};

const zh_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 个性设定已生成 ✨`)
};

const ar_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إنشاء شخصية الذكاء الاصطناعي ✨`)
};

const id_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kepribadian AI dibuat ✨`)
};

const it_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalità dell'IA generata ✨`)
};

const ru_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индивидуальность ИИ сгенерирована ✨`)
};

const pt_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalidade de IA gerada ✨`)
};

const ko_ai_personality_generated = /** @type {(inputs: Ai_Personality_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 페르소나가 생성되었습니다 ✨`)
};

/**
* | output |
* | --- |
* | "AI Personality generated ✨" |
*
* @param {Ai_Personality_GeneratedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_personality_generated = /** @type {((inputs?: Ai_Personality_GeneratedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Personality_GeneratedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_personality_generated(inputs)
	if (locale === "es") return es_ai_personality_generated(inputs)
	if (locale === "fr") return fr_ai_personality_generated(inputs)
	if (locale === "de") return de_ai_personality_generated(inputs)
	if (locale === "ja") return ja_ai_personality_generated(inputs)
	if (locale === "zh") return zh_ai_personality_generated(inputs)
	if (locale === "ar") return ar_ai_personality_generated(inputs)
	if (locale === "id") return id_ai_personality_generated(inputs)
	if (locale === "it") return it_ai_personality_generated(inputs)
	if (locale === "ru") return ru_ai_personality_generated(inputs)
	if (locale === "pt") return pt_ai_personality_generated(inputs)
	return ko_ai_personality_generated(inputs)
});